import { hasAccountCampaign } from "@/entities/account"
import { AccountCampaignSlug } from "@/entities/accountCampaign"
import { type FragmentOf, graphql, readFragment } from "@/graphql"

const graphQLFragments = {
    account: graphql(
        `
            fragment isElmyAccount_Account on AccountType {
                ...hasAccountCampaign_Account
            }
        `,
        [hasAccountCampaign.fragments.account]
    ),
}

export function isElmyAccount(fragment: FragmentOf<typeof graphQLFragments.account>) {
    const account = readFragment(graphQLFragments.account, fragment)

    return hasAccountCampaign(account, AccountCampaignSlug.ElmyClient)
}

isElmyAccount.fragments = graphQLFragments
